import Information from "@/components/Information";
import BillComparison from "@/components/BillComparison";
import IconGrid from "@/components/IconGrid";
import CtaLarge from "@/components/CtaLarge";
import FaqGrid from "@/components/FaqGrid";
import Awards from "@/components/Awards";
import CtaSmall from "@/components/CtaSmall";
import FaqStacked from "@/components/FaqStacked";
import StepFooter from "@/components/StepFooter";

export default function EstimateContent() {

    const content = window.ein?.content?.step_5 || {}

    const {info_block, moving_bill, icon_grid, cta_large, faq_grid, awards, cta_small, faq_list} = content

    return (
        <div className={"grid grid-cols-4 lg:grid-cols-12 gap-x-[20px] lg:gap-x-[32px] gap-y-[80px] mt-[56px]"}>
            {info_block?.show && (
                <div className="col-span-4 lg:col-span-8 lg:col-start-3">
                    <Information/>
                </div>
            )}
            {moving_bill?.show && (
                <div className="col-span-4 lg:col-span-8 lg:col-start-3">
                    <BillComparison/>
                </div>
            )}
            {icon_grid?.show && (
                <div className={"col-span-4 lg:col-span-12 flex flex-col justify-center"}>
                    <IconGrid/>
                </div>
            )}
            {cta_large?.show && (
                <div className="col-span-4 lg:col-span-12">
                    <CtaLarge/>
                </div>
            )}
            {faq_grid?.show && (
                <div className="col-span-4 lg:col-span-12">
                    <FaqGrid/>
                </div>
            )}
            {awards?.show && (
                <div className="col-span-4 lg:col-span-12">
                    <Awards/>
                </div>
            )}
            {cta_small?.show && (
                <div className="col-span-4 lg:col-span-12">
                    <CtaSmall/>
                </div>
            )}
            {faq_list?.show && (
                <div className="col-span-4 lg:col-span-8 lg:col-start-3">
                    <FaqStacked/>
                </div>
            )}
            <div className="col-span-4 lg:col-span-12">
                <StepFooter/>
            </div>
        </div>
    )
}
